import { useEffect, useState } from 'react';
// Forecasting is GLOBAL data shared across sites — read from forecastDb (the
// producing project's Firestore; aliases the primary db on the chadha build).
import firebase, { forecastDb as db } from '../firebaseConfig';

// Animated ocean-basin swell maps. The backend swell-map worker renders a
// streaming MP4 per basin per period-filter variant (10 weeks of history + the
// 16-day forecast, heatmap + coastlines + arrows + date baked in) and stores a
// small metadata doc per basin in `swellMaps/{basinId}` with the variant URLs.

const ready = () => firebase.apps.length > 0 && db;
const COL = 'swellMaps';

export const BASIN_ORDER = [
  'world',
  'pacific',
  'north-atlantic',
  'south-atlantic',
  'indian',
  'rote',
  'rote-sw',
];

// Subscribe to all basin docs (live). Returns { basins: {id->doc}, loading }.
export function useSwellMaps() {
  const [state, setState] = useState({ basins: {}, loading: true });
  useEffect(() => {
    if (!ready()) {
      setState({ basins: {}, loading: false });
      return undefined;
    }
    const unsub = db.collection(COL).onSnapshot(
      (snap) => {
        const basins = {};
        snap.docs.forEach((d) => {
          basins[d.id] = { id: d.id, ...d.data() };
        });
        setState({ basins, loading: false });
      },
      () => setState({ basins: {}, loading: false })
    );
    return () => unsub();
  }, []);
  return state;
}
